export const EDIT_SUCCESS = 'Тариф обновлен';
export const EDIT_ERROR = 'Не удалось обновить тариф';
